import { Suspense } from 'react';
import { AppRouter } from '@/routes/AppRouter';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

export default function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<div>Loading…</div>}>
        <AppRouter />
      </Suspense>
    </ErrorBoundary>
  );
}
